export const getBaseUrl = () => {
    if (window.location.hostname.includes('dev.evbqa.com')) {
        // Return the QA host so that testers do not need to run the local dev server.
        // Update this value to https://dev.evbqa.com:4000 if you want to test against local dev.
        return 'https://www.evbqa.com';
    }

    return ''; // Use same host as the current page.
};
